import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  DataApiResponse,
  EditUserDreamProfessionListModel,
  EditUserWorkHistoryListModel,
  ProfessionAliasModel,
  UserDreamProfessionModel,
  UserWorkHistoryModel,
} from '@digilize/shared/definitions/src';

@Injectable({
  providedIn: 'root',
})
export class ProfessionsService {
  private readonly http = inject(HttpClient);

  getListOfProfessions = (searchValue: string) =>
    this.http.get<DataApiResponse<ProfessionAliasModel[]>>('/api/v1.0/professions/', {
      params: {
        'search.value': searchValue,
        length: 10,
      },
    });

  getListOfProfessionsParams = (params: { [key: string]: string | number }) =>
    this.http.get<DataApiResponse<ProfessionAliasModel[]>>('/api/v1.0/professions/', {
      params,
    });

  getProfessionsMy = () => this.http.get<DataApiResponse<UserWorkHistoryModel[]>>('/api/v1.0/my/professions');

  putProfessionsMy = (req: EditUserWorkHistoryListModel) =>
    this.http.put<DataApiResponse<UserWorkHistoryModel[]>>('/api/v1.0/my/professions', req);

  getDreamProfessionsMy = () =>
    this.http.get<DataApiResponse<UserDreamProfessionModel[]>>('/api/v1.0/my/dream-professions');

  putDreamProfessionsMy = (req: EditUserDreamProfessionListModel) =>
    this.http.put<DataApiResponse<UserDreamProfessionModel[]>>('/api/v1.0/my/dream-professions', req);
}
